module.exports = __webpack_public_path__ + "static/media/CloseTableGray.5c7452d4.svg";